import BossModel from "@/models/BossModel";
import constants from '@/constants';
import WebsiteProduct from "@/models/WebsiteProduct/WebsiteProduct";

export default class WebsiteProductText extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-product/text';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteProductTexts';

    static fields() {
        return {
            id: this.number(null).nullable(),
            text: this.attr(null),
            website_product_text_type_cid: this.attr(null),
            website_product_id: this.number(null).nullable(),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            productTexts: this.belongsTo(WebsiteProduct,'id','website_product_id')
        }
    }

    /**
     *
     * @param data
     */
    constructor(data) {
        super(data);
        if(data.website_product_text_type_cid !== undefined
            && data.website_product_text_type_cid !== null
            && data.text !== undefined
            && data.text !== null){
            this[constants.product_text_types.find(type =>  type.id == data.website_product_text_type_cid).value]= data.text;
        }
    }

    /**
     *
     * @returns {Promise<AxiosResponse<T>>}
     * @constructor
     */
    Update() {
        this.__resolveTypeToText();
        return this.api().update();
    }

    /**
     *
     * @returns {Promise<AxiosResponse<T>>}
     * @constructor
     */
    Save() {
        this.__resolveTypeToText();
        return this.constructor.api().create(this);
    }

    /**
     *
     * @private
     */
    __resolveTypeToText(){
       this.text =  this[constants.product_text_types.find(type =>  type.id == this.website_product_text_type_cid).value]
    }

    static byWebsiteProductId(websiteProductId){
        return this.query().where('website_product_id',websiteProductId).all()
    }

}
